module.exports = __webpack_public_path__ + "assets/img/yins.969a4e39.png";